import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

// @mui
import {
  Box,
  Grid,
  Card,
  Divider,
  Container,
  Typography,

} from '@mui/material';
import ReactToPrint from 'react-to-print';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../components/Iconify';
import Image from '../../components/Image';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
import Scrollbar from '../../components/Scrollbar';
// utils
// import { fCurrency } from '../../utils/formatNumber';
// hooks
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import axios from '../../utils/axios';
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
import styles from './style.css';
import { APP_NAME } from '../../config';
import { InvoiceToolbar } from '../../sections/@dashboard/invioce/data_adex_success';





// ----------------------------------------------------------------------


export default function DataCardPrint() {
  const { themeStretch } = useSettings();
  const { name = '' } = useParams();
  const [trans, Settrans] = useState('');
  const { setting } = useAuth();
  const [load, SetLoad] = useState(true);
  const [map, setMap] = useState([])
  const isDesktop = useResponsive('up', 'sm');
  const theme = useTheme();

  const DataCardPrint = useRef();



  useEffect(() => {
    axios.get(`/api/data_card/trans/${name}/secure/sucess`).then(data => {
      Settrans(data.data?.trans);
      setMap(data?.data?.card_map);
      SetLoad(false);
    }).catch(() => SetLoad(false));
  }, [name, Settrans]);

  return (
    <Page title="Data Card: Invoice">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Data Card Printing "
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Data Card Printing' },
          ]}
        />

        {trans && <InvoiceToolbar invoice={trans} MapData={map} />}


        <Card sx={{ pt: 5, px: 5 }}>
          <Grid container>
            <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
              <Image disabledEffect visibleByDefault alt="logo" src="/upload/welcome.png" sx={{ maxWidth: 120 }} />
            </Grid>

            <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
              <Box sx={{ textAlign: { sm: 'right' } }}>
                <Label color={trans?.plan_status === 1 ? 'success' : 'error'} sx={{ textTransform: 'uppercase', mb: 1 }}>
                  {trans?.plan_status === 1 && 'successful' || trans?.plan_status === 0 && 'proccessing' || trans?.plan_status === 2 && 'failed'}
                </Label>
                <Typography variant="h6">{trans?.transid}</Typography>
              </Box>
            </Grid>
          </Grid>

          {load && <Typography variant="h6" style={{ "text-align": "center" }}>Please Wait ....</Typography>}

          <Scrollbar>
            <table ref={DataCardPrint} >
              <tr  >

                <Grid container={isDesktop}  >
                  {map.map((card, index) => (
                    <>
                      <Grid item lg={12 / 3} key={index} >
                        <td style={{ "borderWidth": "1px", 'borderColor': `${theme.palette.primary.main}`, 'borderStyle': 'solid', border: `4px solid ${theme.palette.primary.main}`, "padding": '4px', "font-size": "10px", maxWidth: '50%' }}>
                          <center> <span style={{ "font-weight": "bolder", "font-size": "18px" }}> {trans?.card_name} </span> <span style={{ "font-weight": "bolder", "font-size": "18px", "float": "right" }}> <img src={trans?.network === 'MTN' && '/upload/mtn.png' || trans?.network === 'AIRTEL' && '/upload/airtel.png' || trans?.network === 'GLO' && '/upload/glo.png' || trans?.network === '9MOBILE' && '/upload/mobile.png'} alt='logo' /></span></center> <br />
                          <p> <span style={{ "font-weight": "bolder", "font-size": "20px" }}>DATA CARD</span> <span style={{ "font-weight": "bolder", "font-size": "18px", "float": "right" }}>{trans?.plan_name}</span>
                          </p> <br />

                          <div className="content" style={{ "padding-left": "10px", "margin-top": "-19px" }}>

                            <span><b>PIN:</b></span>&nbsp;&nbsp;<span style={{ "font-weight": "bolder", "font-size": "18px" }}><b>{card?.pin}</b></span><br />
                            <span><b>S/N:</b></span>&nbsp;&nbsp;<span><b>{card?.serial}</b></span><br />
                            <span><b>Date:</b></span>&nbsp;&nbsp;<span><b>{card?.date}</b></span><br />
                            <span style={{ "font-size": "14px" }}> <b> Dial {trans?.load_pin}  to Load</b></span>
                          </div>
                          <div className={styles}>


                            <center>
                              <span style={{ "font-size": "14px" }}><b>Check Bal:</b></span>&nbsp;&nbsp;<span style={{ "font-size": "14px" }}><b> {trans?.check_balance}</b></span><br />

                              <p style={{ "text-align": "center" }}><b>Powered by {APP_NAME}</b></p>

                            </center>

                          </div>
                        </td>
                      </Grid>
                    </>
                  ))}
                </Grid>
              </tr>

            </table>

          </Scrollbar>






          <Divider sx={{ mt: 5 }} />

          <Grid container>
            <Grid item xs={12} md={9} sx={{ py: 3 }}>
              <Typography variant="subtitle2">NOTES</Typography>
              <Typography variant="body2">
                We appreciate your continuous patronage. Your satisfaction is our top priority!
              </Typography>
            </Grid>
            <Grid item xs={12} md={3} sx={{ py: 3, textAlign: 'right' }}>
              <Typography variant="subtitle2">any enquiry, kindly contact us @</Typography>
              <Typography variant="body2">{setting?.general?.app_email}</Typography>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Page>
  );
}
